import { FlatCard } from './FlatCard';
import { FlatCardBody } from './FlatCardBody/FlatCardBody';

export { FlatCard, FlatCardBody };
